import { createAsyncThunk } from '@reduxjs/toolkit'
import submitFinalized from '../../api/submitFinalized'
import logFormData from '../../api/logFormData'
import toEoiApplicationPayload from '../mapping/toEoiApplicationPayload'
import REQUEST_STATUS from '../common/REQUEST_STATUS'
import ReactGA from 'react-ga'
import { PRODUCTS } from '../../constant/PRODUCTS'

export const submitForm = createAsyncThunk(
  'form/submit',
  async (_, { getState }) => {
    const formData = getState().form
    ReactGA.event({
      category: 'submit', action: 'group', label: formData.segments.employer.fields.groupNumber.value
    })
    ReactGA.event({
      category: 'submit', action: 'state', label: formData.options.homeState.value
    })
    PRODUCTS.forEach(product => {
      if (formData.options[product].value) {
        ReactGA.event({ category: 'submit', action: 'product', label: product })
      }
    })
    // Log the raw form data before mapping and submission
    const payload = toEoiApplicationPayload(formData, true)
    await logFormData(formData)
    return await submitFinalized(payload)
  }
)

export const submitFormReducer = {
  [submitForm.pending]: (state) => {
    state.status = REQUEST_STATUS.IN_PROGRESS
  },
  [submitForm.fulfilled]: (state, action) => {
    state.data = action.payload
    state.status = REQUEST_STATUS.SUCCEEDED
  },
  [submitForm.rejected]: (state, action) => {
    state.error = action.error.message
    state.status = REQUEST_STATUS.FAILED
  }
}